var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLandingPageFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5888 0.61377H1.92216C1.27699 0.61377 0.755493 1.13527 0.755493 1.78044V4.8021C0.755493 5.41227 1.00399 6.01194 1.43566 6.4436L7.75549 12.7634V21.6138C7.75549 22.0186 7.96549 22.3931 8.30966 22.6066C8.49633 22.7221 8.70866 22.7804 8.92216 22.7804C9.10066 22.7804 9.27916 22.7396 9.44366 22.6579L14.1103 20.3246C14.5058 20.1263 14.7555 19.7226 14.7555 19.2804V12.7634L21.0753 6.4436C21.507 6.01194 21.7555 5.41227 21.7555 4.8021V1.78044C21.7555 1.13527 21.234 0.61377 20.5888 0.61377ZM12.764 11.4556C12.5447 11.6738 12.4222 11.9701 12.4222 12.2804V18.5594L10.0888 19.7261V12.2804C10.0888 11.9701 9.96633 11.6738 9.74699 11.4556L3.08883 4.8021V2.9471H19.4233L19.4257 4.79394L12.764 11.4556Z",
    fill: "#E04F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLandingPageFilter);
export default __webpack_public_path__ + "static/media/icon-landing-page-filter.0d0f17a3077523f220a2b14ff5013f02.svg";
export { ForwardRef as ReactComponent };